/**
 * Map of available plugins.
 */
export const PLUGINS = {
  mixpanel: 'mixpanel',
};
